<template>
    <span style="min-height: 100vh">
        <v-container class="paddingLeft" fluid style="padding-top: 70px;padding-left: 80px" >
            <v-flex lg-12 class="row  pl-lg-3">
                <v-card-text class="display-1 font-weight-thin">Bienvenido de nuevo</v-card-text>
            </v-flex>
        </v-container>
        <v-container fluid style="padding-top: 10px; width: 100%" class="grey lighten-4 pad2">
            <my_-courses class="pl-lg-3 pl-sm-0"></my_-courses>
        </v-container>
    </span>
</template>
<script>
    import {mapState} from 'vuex'

    import My_Courses from './getCoursesRegister.vue'
    export default {
        name: 'MyCourses',
        components: {
            /* eslint-disable */
            My_Courses,
        },
        created(){

        },
        data(){
            return {

            }
        },
        computed: {
            ...mapState,


        },
        methods:{

        }

    }
</script>
<style>
    .pad2{
        padding-left: 80px!important;
    }
    @media screen and (max-width: 900px) {
        .hide {
            display: none !important;
        }
    }

    @media screen and (max-width: 768px) {
        .paddingLeft{
            padding-left: 0!important;
        }
        .pad2{
            padding-left: 30px!important;
        }

    }

</style>